export default (digits: string) => {
  return digits.replace(/\D/g, '');
};